import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import ReactFlagsSelect from 'react-flags-select';

const mapDispatchToProps = dispatch => ({
});
const mapStateToProps = state => {
  
};

class Header extends React.Component {

  render() {
    return (
      <div className="container">
        <div className="row">
          <div className="col-md-2">
            <Link to="/" id="logo" className="">

            </Link>
          </div>
          <div className="col-md-8">
            <h1 className="logo-font">
              {this.props.appName}
            </h1>
            <p className="text-right"><span><i className="icon ion-ios-telephone"></i></span> 27845942 Gunārs</p>
          </div>
          <div className="col-md-2">
            <ReactFlagsSelect
              className="country-select"
              placeholder="Izvēlies valodu"
              selected={this.props.language}
              onSelect={code => this.props.langFunc(code)}
              countries={["LV", "GB", "RU"]}
              customLabels={{
                "LV": { primary: "Latviski"},
                "GB": { primary: "English"},
                "RU": { primary: "Pусский" } 
              }}
            />            
          </div>
        </div>
      </div>

    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/Header.js